import { FormControl, FormLabel, Select } from '@chakra-ui/react';
import { strings } from 'config/localization';
import { PAGE_LIMITS } from 'constants/common';
import * as React from 'react';

export interface PageLimitChangerProps {
  pageSize: number | string;
  setPageSize: (page: number) => void;
}

const PageLimitChanger: React.FC<PageLimitChangerProps> = (props) => {
  const { pageSize, setPageSize } = props;
  return (
    <FormControl display="flex" alignItems="center" justifyContent="flex-end">
      <FormLabel
        color="gray.400"
        fontSize="md"
        fontWeight="normal"
        mb={0}
        minWidth="70px">
        {strings.show_rows}
      </FormLabel>
      <Select
        size="sm"
        isFullWidth={false}
        variant="filled"
        bgColor="white"
        width="35"
        value={pageSize}
        onChange={(e: React.ChangeEvent<HTMLSelectElement>) =>
          setPageSize(+e.target.value)
        }>
        {PAGE_LIMITS.map((item) => (
          <option value={item} key={item}>
            {item}
          </option>
        ))}
      </Select>
    </FormControl>
  );
};

export default PageLimitChanger;
